import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { forwardRef, useContext, useEffect, useImperativeHandle, useRef, useState, } from 'preact/compat';
import { OptionsCTX } from '@bookingForm/context/Options';
import StyledElements from './styles';
const LoadingDates = forwardRef((props, forwardedRef) => {
    const [working, setWorking] = useState(false);
    const [finished, setFinished] = useState(false);
    const [percentage, setPercentage] = useState('0%');
    const { findingSessionsText } = useContext(OptionsCTX);
    const wrapper = useRef(null);
    const inner = useRef(null);
    async function stall(stallTime = 3000) {
        await new Promise((resolve) => setTimeout(resolve, stallTime));
    }
    const childFunction = async () => {
        setWorking(false);
        setFinished(true);
        await stall(400);
        return Promise.resolve(true);
    };
    useImperativeHandle(forwardedRef, () => ({
        childFunction,
    }));
    useEffect(() => {
        const interval = setInterval(() => {
            const innerWidth = inner.current?.offsetWidth ?? null;
            const wrapperWidth = wrapper.current?.offsetWidth ?? null;
            if (innerWidth && wrapperWidth) {
                const percent = Math.round((innerWidth / wrapperWidth) * 100);
                setPercentage(`${percent}%`);
            }
        }, 300);
        return () => clearInterval(interval);
    }, []);
    useEffect(() => {
        setWorking(true);
    }, []);
    return (_jsxs(StyledElements.Wrapper, { children: [findingSessionsText && (_jsx(StyledElements.Message, { children: findingSessionsText })), _jsx(StyledElements.Percentage, { children: percentage }), _jsx(StyledElements.LoadingBar, { ref: wrapper, children: _jsx(StyledElements.LoadingBarInner, { working: working, finished: finished, ref: inner }) })] }));
});
export default LoadingDates;
